import TrypAccordion from "../../Pages/Tryps/components/TrypAccordion";
import {
  getTrypTime,
  useGetFullDate,
  useGetTrypLength,
} from "../../common/Utils/TimeUtils";
import { getTrypDistance } from "../../common/Utils/Utils";

const RenderTrypAccordion = (props) => {
  const { tryp, disable = false } = props;
  const statNames = {
    acceleration: "acceleration",
    alert: "focus",
    cool: "handling",
    cornering: "cornering",
    deceleration: "brake",
    eco: "eco",
    jerk: "steadiness",
    phoneHandling: "phone",
    speeding: "speed",
    swerve: "swerve",
    total: "total",
  };
  const scores = {};
  Object.entries(tryp.score).forEach(([key, value]) => {
    scores[statNames[key]] = tryp.score[key] === null ? 0 : Math.round(value);
  });

  const getFullDate = useGetFullDate();
  const getTrypLength = useGetTrypLength();

  return (
    <TrypAccordion
      date={getFullDate(new Date(tryp.createdAt))}
      time={getTrypTime(new Date(tryp.startTime), new Date(tryp.endTime))}
      length={getTrypLength(new Date(tryp.startTime), new Date(tryp.endTime))}
      distance={getTrypDistance(tryp.distanceMeters)}
      scores={scores}
      events={tryp.telematicsEvents}
      isDisabled={disable}
    />
  );
};

export default RenderTrypAccordion;
